import { TextField } from "@mui/material"
import { useState } from "react";
import Swal from "sweetalert2";
import { uploadFile } from "../../../services/uploadFile";

export const FileUploadCustom = ({ 
    helperText = '', 
    parentCallback,
    parentWaitingCallback,
    saveFileAs = '',
    variant = 'filled',
    validTypes = ['pdf'],
    maxFileWeight = 2000000,
}) => {


    // // state para el fileupload
    // const [file, setFile] = useState({
    //     file: '',
    // });

    // Al seleccionar el archivo a subir
    const handleFileChange = async({ target }) => {
        const fileToUpload = target.files[0];
        console.log({ fileToUpload });

        // No se eligio archivo o se presiono cancel en el file dialog
        if (!fileToUpload) { return; }

        const fullName = fileToUpload.name;
        const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toLowerCase();
        console.log({fileExt});

        // No es el tipo indicado, avisar y cancelar upload
        if (!validTypes.includes(fileExt)) {
            Swal.fire(
                'Tipo de archivo inválido', 
                `El documento debe estar en ${ validTypes.length > 1 ? `cualquiera de los siguientes formatos` : `formato`}: ${ validTypes.join(', ') }.`, 
                'warning'
            );
            return;
        }

        // No es del peso indicado, avisar y cancelar upload
        if (fileToUpload.size > maxFileWeight) {
            Swal.fire(
                `El límite es de ${ maxFileWeight / 1000000 } MB`, 
                `El archivo superó el máximo establecido.`, 
                'warning'
            );
            return;
        }

        // TODO: subir archivo
        parentWaitingCallback(true);

        const file = { file: fileToUpload };
        const fullNameToUse = `${ saveFileAs }.${ fileExt }`;
        console.log({file, fullNameToUse});

        const resultUpload = await uploadFile({file, fileName: fullNameToUse});
        console.log({resultUpload});

        parentWaitingCallback(false);
        
        parentCallback(resultUpload);
        // const fileURL = 'ok';
        // parentCallback(fileURL);
    };


    return (
        <>
            <TextField
                type='file'
                onChange={ e => handleFileChange(e) }
                fullWidth
                variant={ variant } 
                helperText={ helperText } 
            />
        </>
    )
}
